/* eslint-disable @typescript-eslint/ban-types */
import { IInitialState } from "../CreateSchedule/redux/Types";
import { DAY_END_LIMIT, END_AFTER, END_AFTER_LIMIT, END_AFTER_START, END_BY, START_DATE } from "../Helper/Constants";
import { convertDateToView, getFormattedDate } from "../Helper/Script";
import { IValidationType } from "./SchedulingDetails/Common/ScheduleCreationForm.logic";
import { RecursTypes } from "./Types";

export const IsDateValid = (selectedDate: string | Date,
  translate: Function, dateType: string, endByDate?: string): IValidationType => {

  const convertedSelectedDate = getFormattedDate(selectedDate as Date, false);
  const todayDate = getFormattedDate(new Date(), false);
  const currentStartDate = selectedDate ? convertedSelectedDate : todayDate;
  const convertedDate = dateType === START_DATE ? convertedSelectedDate :
    endByDate && getFormattedDate(new Date(endByDate), false);
  const currentDate = dateType === START_DATE ? todayDate : currentStartDate;
  const reversedConvertedDate = convertedDate && convertDateToView(convertedDate);
  const reversedCurrentDate = convertedDate && convertDateToView(currentDate);

  if(reversedConvertedDate && reversedCurrentDate &&
    (new Date(reversedConvertedDate).valueOf() < new Date(reversedCurrentDate).valueOf())){
    return {
      isInvalid: false,
      validationText: dateType === START_DATE ?
        translate("Scheduling.ScheduleErrors.StartDateError"):
        translate("Scheduling.ScheduleErrors.EndDateError")
    };
  }
  return {
    isInvalid: false,
    validationText: ""
  };

};

export const EmptyFieldValidation = (value: string, translate: Function, fieldName?: string): IValidationType => {
  if (value === "") {
    return {
      isInvalid: true,
      validationText: translate("Scheduling.ScheduleErrors.MandatoryFieldError"),
    };
  }
  else if(fieldName === "endAfterValue" &&
    Number(value) > END_AFTER_LIMIT || Number(value) < END_AFTER_START){
    return {
      isInvalid: false,
      validationText: translate("Scheduling.ScheduleErrors.OccurenceRangeLimit"),
    };
  }else if(fieldName === "monthDayId" &&
    (Number(value) < END_AFTER_START || Number(value) > DAY_END_LIMIT)){
    return {
      isInvalid: false,
      validationText: translate("Scheduling.ScheduleErrors.DayRangeLimit"),
    };
  }
  return {
    isInvalid: false,
    validationText: ""
  };
};

export const getEndByDateDefaultValue = (reccurenceStart: string,
  recurType: string): any => {
  const startDate = reccurenceStart ?
    reccurenceStart :
    new Date().getDate()+"-"+new Date().getMonth()+"-"+new Date().getFullYear();
  const startDateCopy = convertDateToView(startDate);
  const val = Object.keys(startDate).length === 0 && startDate.constructor === Object;
  if(!val) {
    switch(recurType) {
      case RecursTypes.Daily:{
        return startDateCopy.setDate(startDateCopy.getDate()+1);
      }
      case RecursTypes.Weekly:{
        return startDateCopy.setDate(startDateCopy.getDate()+7);
      }
      case RecursTypes.Monthly:{
        return startDateCopy.setDate(startDateCopy.getDate()+30);
      }
      case RecursTypes.Quarterly:{
        return startDateCopy.setDate(startDateCopy.getDate()+90);
      }
      case RecursTypes.Yearly:{
        return startDateCopy.setDate(startDateCopy.getDate()+365);
      }
    }
  }
};

export const getSelectedEndDateValues = (scheduleDetails: IInitialState): string =>{
  if(scheduleDetails?.isEndBy)
    return END_BY;
  return END_AFTER;
};
